import { jsx as n, Fragment as k, jsxs as r } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import w from "./logo.webp.js";
import $ from "./menu-dropdown-wrapper-mobile.svg.js";
import v from "./burger.svg.js";
import O from "./close.svg.js";
import { useState as C, useCallback as h, useMemo as y } from "react";
import { AccountLink as A } from "./account-link/index.js";
import G from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as x } from "./dropdown-menu-item/index.js";
import { useDisableScroll as S } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as H } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { MobileAccountModalLink as R } from "./mobile-account-modal/index.js";
import { ForLawyersMenuButtonMobile as T } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemMobile as I } from "./get-help-menu-item/index.js";
import { GradientButton as q } from "./gradient-button/index.js";
import { MenuChatButtonMobile as B } from "./chat-button/index.js";
import j from "./chevron-right-gradient.svg.js";
const le = (a) => {
  const {
    isAuthenticated: c,
    openAuthModal: t,
    getTranslation: s,
    language: g,
    onRequestLawyer: o
  } = a, [u, m] = C(!1);
  S({ isDisabled: u });
  const p = h(() => {
    m(!0);
  }, []), l = h(() => {
    m(!1);
  }, []), i = h(() => {
    m(!1), c || t();
  }, [c, t]), d = h(() => {
    m(!1), a.logout();
  }, [a.logout]);
  return /* @__PURE__ */ n(k, { children: /* @__PURE__ */ r(
    "div",
    {
      className: `${e.menuModalOverlay} ${u ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ n(
          F,
          {
            isMenuOpen: u,
            closeMenu: l,
            openMenu: p,
            onAccountClick: i,
            handleLogout: d,
            isAuthenticated: a.isAuthenticated,
            userImage: a.userImage,
            hasNotifications: a.hasNotifications,
            language: g,
            getTranslation: s,
            isLawyerSupported: a.isLawyerSupported,
            onRequestLawyer: o
          }
        ),
        /* @__PURE__ */ n(
          W,
          {
            isAuthenticated: a.isAuthenticated,
            language: g,
            handleLogout: d,
            closeMenu: l,
            hasNotifications: a.hasNotifications,
            userImage: a.userImage,
            onAccountClick: i,
            getTranslation: s,
            isLawyerSupported: a.isLawyerSupported,
            onRequestLawyer: o
          }
        ),
        /* @__PURE__ */ n($, { className: e.mobileBGIcon })
      ]
    }
  ) });
}, F = (a) => {
  const {
    isMenuOpen: c,
    closeMenu: t,
    openMenu: s,
    onAccountClick: g,
    handleLogout: o,
    isAuthenticated: u,
    hasNotifications: m,
    userImage: p,
    language: l,
    getTranslation: i,
    isLawyerSupported: d,
    onRequestLawyer: f
  } = a, [N, M] = C(!1), L = h(() => {
    M(!0);
  }, []), b = h(() => {
    M(!1);
  }, []);
  return /* @__PURE__ */ r("div", { className: e.mobileMenuContainer, children: [
    /* @__PURE__ */ n(
      "div",
      {
        className: e.menuIconContainer,
        onClick: c ? t : s,
        children: /* @__PURE__ */ r("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ n(
            "img",
            {
              src: v,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${c ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ n(
            "img",
            {
              src: O,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${c ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ n(
      "a",
      {
        href: l ? `/${l}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ n(
          "img",
          {
            src: w,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    u ? /* @__PURE__ */ n(
      A,
      {
        isAuthenticated: u,
        userImage: p,
        openAuthModal: g,
        logout: o,
        hasNotifications: m,
        closeMenuModal: t,
        language: l,
        getTranslation: i
      }
    ) : d ? /* @__PURE__ */ r(k, { children: [
      /* @__PURE__ */ n(
        q,
        {
          label: i("pages.get-help"),
          onClick: L,
          className: e.mobileMenuGradientButton
        }
      ),
      /* @__PURE__ */ n(
        I,
        {
          language: l || "en",
          titleLabel: i("pages.get-help"),
          getTranslation: i,
          isLawyerSupported: d,
          onRequestLawyer: f,
          closeMenu: b,
          externalIsOpen: N,
          externalOnOpen: L,
          externalOnClose: b,
          hideDefaultTrigger: !0
        }
      )
    ] }) : /* @__PURE__ */ n(B, { getTranslation: i })
  ] });
}, W = (a) => {
  const {
    handleLogout: c,
    language: t,
    closeMenu: s,
    onAccountClick: g,
    getTranslation: o,
    isLawyerSupported: u,
    onRequestLawyer: m
  } = a, [p, l] = C(!1), i = h(() => {
    l(!0);
  }, []), d = h(() => {
    l(!1);
  }, []), f = y(() => {
    var M;
    const N = (M = H[t]) == null ? void 0 : M.map((L) => ({
      ...L,
      path: `/${t}/topics/${D(L.title)}`
    }));
    return N || null;
  }, [t]);
  return /* @__PURE__ */ r("div", { className: e.menuModalContent, children: [
    /* @__PURE__ */ r("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ r(
        "div",
        {
          className: `${e.mainMenuLink} ${e.gradientText}`,
          onClick: i,
          children: [
            /* @__PURE__ */ n("div", { className: e.gradientTextContent, children: o("pages.get-help") }),
            /* @__PURE__ */ n(j, { className: `${e.arrowIcon}` })
          ]
        }
      ),
      /* @__PURE__ */ n(
        I,
        {
          language: t,
          titleLabel: o("pages.get-help"),
          getTranslation: o,
          isLawyerSupported: u,
          onRequestLawyer: m,
          closeMenu: d,
          externalIsOpen: p,
          externalOnOpen: i,
          externalOnClose: d,
          hideDefaultTrigger: !0
        }
      )
    ] }),
    /* @__PURE__ */ r("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      f && /* @__PURE__ */ n(
        x,
        {
          language: t,
          titleLabel: o("pages.topics"),
          link: `/${t}/topics`,
          items: f,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: `/${t}/about/company`,
          className: e.mainMenuLink,
          onClick: s,
          children: o("pages.about")
        }
      ),
      /* @__PURE__ */ n(
        T,
        {
          language: t,
          getTranslation: o,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      a.isAuthenticated ? /* @__PURE__ */ n(
        R,
        {
          language: t,
          handleLogout: c,
          userImage: a.userImage,
          hasNotifications: a.hasNotifications,
          getTranslation: o
        }
      ) : /* @__PURE__ */ r("div", { className: e.mainMenuLink, onClick: g, children: [
        o("pages.account"),
        /* @__PURE__ */ n(G, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ r("div", { className: e.menuLinksContainer, children: [
      t.includes("en") && /* @__PURE__ */ n(
        "a",
        {
          href: t ? `/${t}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: s,
          children: o("pages.insights")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: t ? `/${t}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: s,
          children: o("pages.faqs")
        }
      ),
      f && /* @__PURE__ */ n(
        "a",
        {
          href: t ? `/${t}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: s,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: t ? `/${t}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: s,
          children: o("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  le as MobileMenu
};
